import React, {useEffect} from 'react';
import LandingPage from './components/pages/LandingPage';
import SurveyPage from './components/pages/SurveyPage';
import SummaryPage from './components/pages/SummaryPage';
import DetailsPage from './components/pages/DetailsPage';
import ProgressBar from './components/ProgressBar';
import Header from "./components/Header";
import Footer from "./components/Footer";
import { GuideAppContainer, PageContainer, RenderOnlyFor, GuideProgress, NeuroMessage, PageNavigation, useNeuroState, useDispatch } from '@ignitesales/neuro-application';
import {checkAndGoToDeepLink} from "./actions/regions-consumer-online-actions";

const App = () => {
  const dispatch = useDispatch();
  const { redirectToPath, redirectType, regionsAppIsReady } = useNeuroState();

  useEffect(() => dispatch(checkAndGoToDeepLink()), []);

  useEffect(() => {
    if(redirectToPath){ window.location.href = redirectToPath; }
  }, [redirectToPath]);

  return regionsAppIsReady ? <GuideAppContainer>
    { redirectToPath && <div className="redirectLoadingOverlay animated fadeIn" aria-live="polite"><NeuroMessage id={`redirectMessage.${redirectType}`} /></div>}
    <Header />
    <RenderOnlyFor forSurveyPage={true}>
      <GuideProgress render={ props => <ProgressBar {...props} /> } />
    </RenderOnlyFor>
    <PageContainer
      LandingPage={LandingPage}
      SurveyPage={SurveyPage}
      SummaryPage={SummaryPage}
      DetailsPage={DetailsPage}
      transitionTimeout={1500}
    />
    <RenderOnlyFor forSurveyPage={true}>
      <PageNavigation
        className='survey'
        innerNextBtn={ <NeuroMessage id='nav.next' /> }
        innerPrevBtn={ <NeuroMessage id='nav.prev' /> }
      />
    </RenderOnlyFor>
    <Footer />
  </GuideAppContainer> : null;
};

export default App;

// TODO: refactor this into regions-online-new
